/**
 * T407 client — Admin audit-log list hook.
 */
import { useQuery } from '@tanstack/react-query';
import { api } from '../api';

export interface AdminAuditLogEntryDto {
  id: string;
  actorUserId: string;
  tenantId: string | null;
  action: string;
  targetUserId: string | null;
  targetTenantId: string | null;
  targetResourceType: string | null;
  targetResourceId: string | null;
  detailsJson: Record<string, unknown> | null;
  ipAddress: string | null;
  userAgent: string | null;
  createdAt: string;
}

export interface AdminAuditLogPage {
  items: AdminAuditLogEntryDto[];
  pagination: { page: number; limit: number; total: number; totalPages: number };
}

export interface AdminAuditQuery {
  page?: number;
  limit?: number;
  scope?: 'tenant' | 'global';
}

function buildQuery(q: AdminAuditQuery): string {
  const params = new URLSearchParams();
  if (q.page != null) params.set('page', String(q.page));
  if (q.limit != null) params.set('limit', String(q.limit));
  if (q.scope) params.set('scope', q.scope);
  const s = params.toString();
  return s ? `?${s}` : '';
}

export const adminAuditApi = {
  list: (q: AdminAuditQuery = {}) =>
    api.get<AdminAuditLogPage>(`/admin/admin-audit-log${buildQuery(q)}`),
};

export function useAdminAuditLog(q: AdminAuditQuery = {}) {
  return useQuery({
    queryKey: ['admin-audit-log', q],
    queryFn: () => adminAuditApi.list(q),
  });
}
